import { useNavigate, useRouteError } from "react-router-dom";

import { ForbiddenError } from "../errors";
import useAuthContext from "./use-auth-context";

export default function useForbiddenError() {
  let error = useRouteError();
  const navigate = useNavigate();
  const { signOut } = useAuthContext();

  if (error instanceof ForbiddenError) {
    signOut().then(() => navigate("/login"));
  }
}
